import styled from "styled-components";

export const TertiaryButtonGhostText = styled.span`
  font-size: 16px;
  font-weight: normal;
`;

export const TertiaryButtonGhost = styled.button`
  color: var(--ons-color-white);
  border-radius: 3px;
  border: 2px solid var(--ons-color-grey-15);
  background-color: var(--ons-color-ocean-blue);
  padding: 2px 6px;

  &:hover {
    background-color: rgb(from var(--ons-color-night-blue) r g b / 0.6);
    border: 2px solid var(--ons-color-white);
    cursor: pointer;
  }

  &:focus {
    border: 2px solid var(--ons-color-black);
    background-color: var(--ons-color-sun-yellow);
    color: var(--ons-color-black);
  }
`;
